export const VUEX_DRAWER_SHOW = 'VUEX_DRAWER_SHOW'
export const VUEX_DRAWER_HIDE = 'VUEX_DRAWER_HIDE'
